/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date; output: Date };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** Localized string object with language keys */
  LocalizedString: {
    input: Record<Language, string>;
    output: Record<Language, string>;
  };
  /** NiceId scalar type - 8 character lowercase alphanumeric string */
  NiceId: { input: string; output: string };
  /** UUID scalar type */
  UUID: { input: string; output: string };
  _Any: { input: any; output: any };
  federation__FieldSet: { input: any; output: any };
  link__Import: { input: any; output: any };
};

/** User activity level options */
export enum ActivityLevel {
  Active = 'ACTIVE',
  LightlyActive = 'LIGHTLY_ACTIVE',
  NotActive = 'NOT_ACTIVE',
  VeryActive = 'VERY_ACTIVE',
}

export type AiCredits = {
  __typename?: 'AiCredits';
  balance: Scalars['Int']['output'];
  monthlyAllotment?: Maybe<Scalars['Int']['output']>;
};

export type Entitlement = {
  __typename?: 'Entitlement';
  entitlementId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  store?: Maybe<Scalars['String']['output']>;
};

/** User fitness goal options */
export enum FitnessGoal {
  GainWeight = 'GAIN_WEIGHT',
  LoseWeight = 'LOSE_WEIGHT',
  StayFit = 'STAY_FIT',
}

/** User gender options */
export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
}

export enum Language {
  En = 'EN',
  Sk = 'SK',
}

export type Meal = {
  __typename?: 'Meal';
  /** Barcode (UPC/EAN) for commercial products */
  barcode?: Maybe<Scalars['String']['output']>;
  /** Brand name for commercial products */
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<MealCategory>;
  createdAt: Scalars['DateTime']['output'];
  /** Data source (USDA, manual, brand, etc.) */
  dataSource?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Exchange rate to convert serving size to 100g */
  exchangeRateTo100g: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  /** Whether the meal is publicly visible */
  isPublic: Scalars['Boolean']['output'];
  /** Name of the meal */
  name: Scalars['String']['output'];
  nutritionalInfo?: Maybe<MealNutritionalInfo>;
  /** Size of one serving in serving units */
  servingSize: Scalars['Float']['output'];
  /** Unit for measuring serving size */
  servingUnit: ServingUnit;
  servingUnits: Array<MealServingUnit>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  /** When the meal was verified */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MealCategory = {
  __typename?: 'MealCategory';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** Localized category title */
  title?: Maybe<Scalars['LocalizedString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MealInput = {
  /** Allergen ID */
  allergenId?: InputMaybe<Scalars['UUID']['input']>;
  /** Barcode (UPC/EAN) for commercial products */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** Brand name for commercial products */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Carbohydrates per 100g in grams */
  carbs: Scalars['Float']['input'];
  /** Category ID */
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  /** Data source (USDA, manual, brand, etc.) */
  dataSource?: InputMaybe<Scalars['String']['input']>;
  /** Energy content per 100g in kcal */
  energyKcal: Scalars['Float']['input'];
  /** Exchange rate to convert serving size to 100g */
  exchangeRateTo100g: Scalars['Float']['input'];
  /** Fats per 100g in grams */
  fats: Scalars['Float']['input'];
  /** Fibre per 100g in grams */
  fibre: Scalars['Float']['input'];
  /** Whether the meal is publicly visible */
  isPublic: Scalars['Boolean']['input'];
  /** Name of the meal */
  name: Scalars['String']['input'];
  /** Protein per 100g in grams */
  protein: Scalars['Float']['input'];
  /** Size of one serving in serving units */
  servingSize: Scalars['Float']['input'];
  /** Unit for measuring serving size */
  servingUnit: ServingUnit;
  /** Named custom serving units (additive to the 100g base) */
  servingUnits?: InputMaybe<Array<MealServingUnitInput>>;
  /** Sodium per 100g in mg */
  sodium?: InputMaybe<Scalars['Float']['input']>;
  /** Sugar per 100g in grams (part of carbs) */
  sugar?: InputMaybe<Scalars['Float']['input']>;
  /** Water content per 100g in ml (0–100) */
  waterMl?: InputMaybe<Scalars['Float']['input']>;
};

export type MealListQuery = {
  /** Filter by allergen IDs */
  allergenIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by barcode */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** Filter by brand */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Filter by category IDs */
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If true, return the user's own meals plus public meals */
  includeMine?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** If true, return only the user's own created meals */
  onlyMine?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Search by meal name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Return the meal the CMS maps to this special kind (e.g. WATER), ignoring other filters */
  special?: InputMaybe<SpecialMeal>;
  /** Filter by verified meals only */
  verifiedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MealLog = {
  __typename?: 'MealLog';
  /** Amount consumed in meal serving units */
  consumedAmount: Scalars['Float']['output'];
  /** Unit the amount was logged in (a servingUnits name); null = base unit */
  consumedAmountUnit?: Maybe<Scalars['String']['output']>;
  /** When the meal was consumed */
  consumedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Type of meal (breakfast, lunch, etc.) */
  mealType?: Maybe<MealType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MealNutritionalInfo = {
  __typename?: 'MealNutritionalInfo';
  /** Carbohydrates per 100g in grams */
  carbs: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Energy content per 100g in kcal */
  energyKcal: Scalars['Float']['output'];
  /** Fats per 100g in grams */
  fats: Scalars['Float']['output'];
  /** Fibre per 100g in grams */
  fibre: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  /** Protein per 100g in grams */
  protein: Scalars['Float']['output'];
  /** Sodium per 100g in mg */
  sodium?: Maybe<Scalars['Float']['output']>;
  /** Sugar per 100g in grams (part of carbs) */
  sugar?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Water content per 100g in ml (0–100) */
  waterMl?: Maybe<Scalars['Float']['output']>;
};

export type MealResultPage = ResultPage & {
  __typename?: 'MealResultPage';
  /** Current page number (starts from 0). If there are no items, this value is 0. */
  currentPage: Scalars['Int']['output'];
  items: Array<Meal>;
  /** Total number of items based on provided query. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on provided query. If there are no items, this value is 0. */
  totalPages: Scalars['Int']['output'];
};

export type MealServingUnit = {
  __typename?: 'MealServingUnit';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Name of the serving unit (e.g. "Balenie") */
  name: Scalars['String']['output'];
  /** Display order of the serving unit */
  sortIndex: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Gram weight of one of this unit, relative to the 100g base */
  weightGrams: Scalars['Float']['output'];
};

export type MealServingUnitInput = {
  /** Existing serving unit ID (omit when creating) */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of the serving unit (e.g. "Balenie") */
  name: Scalars['String']['input'];
  /** Display order of the serving unit */
  sortIndex: Scalars['Int']['input'];
  /** Gram weight of one of this unit, relative to the 100g base */
  weightGrams: Scalars['Float']['input'];
};

/** Types of meals during the day */
export enum MealType {
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
  Snack = 'SNACK',
}

/** Specific muscle types that can be targeted during exercise */
export enum Muscle {
  Biceps = 'BICEPS',
  Calves = 'CALVES',
  Deltoids = 'DELTOIDS',
  Forearms = 'FOREARMS',
  Glutes = 'GLUTES',
  Hamstrings = 'HAMSTRINGS',
  Heart = 'HEART',
  LatissimusDorsi = 'LATISSIMUS_DORSI',
  LowerBack = 'LOWER_BACK',
  Obliques = 'OBLIQUES',
  PectoralisMajor = 'PECTORALIS_MAJOR',
  PectoralisMinor = 'PECTORALIS_MINOR',
  Quadriceps = 'QUADRICEPS',
  RectusAbdominis = 'RECTUS_ABDOMINIS',
  Rhomboids = 'RHOMBOIDS',
  RotatorCuff = 'ROTATOR_CUFF',
  Trapezius = 'TRAPEZIUS',
  Triceps = 'TRICEPS',
}

/** Muscle groups that exercises can target */
export enum MuscleGroup {
  Arms = 'ARMS',
  Back = 'BACK',
  Cardiovascular = 'CARDIOVASCULAR',
  Chest = 'CHEST',
  Core = 'CORE',
  Legs = 'LEGS',
  Shoulders = 'SHOULDERS',
}

export type MuscleTarget = {
  __typename?: 'MuscleTarget';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  intensity: Scalars['Int']['output'];
  muscle: Muscle;
  muscleGroup: MuscleGroup;
  sportActivityId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MuscleTargetInput = {
  intensity?: Scalars['Int']['input'];
  muscle: Muscle;
  muscleGroup: MuscleGroup;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteCurrentUser: Scalars['Boolean']['output'];
  deleteMeal: Scalars['Boolean']['output'];
  deleteSportActivity: Scalars['Boolean']['output'];
  /** Execute a batch of PowerSync data operations in a transaction */
  executePowerSyncBatch: PowerSyncOperationResult;
  /** Execute a single PowerSync data operation */
  executePowerSyncOperation: PowerSyncOperationResult;
  saveMeal: Meal;
  saveSportActivity: SportActivity;
  updateCurrentUser: User;
};

export type MutationDeleteMealArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteSportActivityArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationExecutePowerSyncBatchArgs = {
  input: PowerSyncBatchInput;
};

export type MutationExecutePowerSyncOperationArgs = {
  input: PowerSyncSingleOperationInput;
};

export type MutationSaveMealArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  input: MealInput;
};

export type MutationSaveSportActivityArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  input: SportActivityInput;
};

export type MutationUpdateCurrentUserArgs = {
  input: UserInput;
};

export type PowerSyncBatchInput = {
  batch: Array<PowerSyncDataOperation>;
};

export type PowerSyncDataOperation = {
  data: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  op: PowerSyncOperation;
  table: Scalars['String']['input'];
};

/** PowerSync data operation type */
export enum PowerSyncOperation {
  Delete = 'DELETE',
  Patch = 'PATCH',
  Put = 'PUT',
}

export type PowerSyncOperationResult = {
  __typename?: 'PowerSyncOperationResult';
  affectedRows?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PowerSyncSingleOperationInput = {
  data: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  op: PowerSyncOperation;
  table: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  _entities: Array<Maybe<_Entity>>;
  _service: _Service;
  currentUser: User;
  languages: Array<Language>;
  meal: Meal;
  mealCategories: Array<MealCategory>;
  meals: MealResultPage;
  mealsByIds: Array<Meal>;
  sportActivities: SportActivityResultPage;
  sportActivity: SportActivity;
};

export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']['input']>;
};

export type QueryMealArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryMealsArgs = {
  query?: InputMaybe<MealListQuery>;
};

export type QueryMealsByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};

export type QuerySportActivitiesArgs = {
  query?: InputMaybe<SportActivityListQuery>;
};

export type QuerySportActivityArgs = {
  id: Scalars['UUID']['input'];
};

export type ResultPage = {
  /** Current page number (starts from 0). If there are no items, this value is 0. */
  currentPage: Scalars['Int']['output'];
  /** Total number of items based on provided query. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on provided query. If there are no items, this value is 0. */
  totalPages: Scalars['Int']['output'];
};

/** Units for measuring meal servings */
export enum ServingUnit {
  Cups = 'CUPS',
  FluidOunces = 'FLUID_OUNCES',
  Grams = 'GRAMS',
  Kilograms = 'KILOGRAMS',
  Litres = 'LITRES',
  Millilitres = 'MILLILITRES',
  Ounces = 'OUNCES',
  Pieces = 'PIECES',
  Pounds = 'POUNDS',
  Slices = 'SLICES',
  Tablespoons = 'TABLESPOONS',
  Teaspoons = 'TEASPOONS',
}

/** Meals with a special product role, mapped to a Meal in the CMS */
export enum SpecialMeal {
  Water = 'WATER',
}

export type SportActivity = {
  __typename?: 'SportActivity';
  category: SportActivityCategory;
  createdAt: Scalars['DateTime']['output'];
  defaultDimensions?: Maybe<Array<WorkoutSetDimension>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  muscleTargets: Array<MuscleTarget>;
  name: Scalars['LocalizedString']['output'];
  user?: Maybe<User>;
};

export type SportActivityCategory = {
  __typename?: 'SportActivityCategory';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['LocalizedString']['output'];
  id: Scalars['UUID']['output'];
  shortDescription: Scalars['LocalizedString']['output'];
  title: Scalars['LocalizedString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SportActivityInput = {
  categoryId: Scalars['UUID']['input'];
  defaultDimensions?: InputMaybe<Array<WorkoutSetDimension>>;
  muscleTargets?: InputMaybe<Array<MuscleTargetInput>>;
  name: Scalars['LocalizedString']['input'];
};

export type SportActivityListQuery = {
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fulltextSearch?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SportActivityResultPage = {
  __typename?: 'SportActivityResultPage';
  /** Current page number (starts from 0). If there are no items, this value is 0. */
  currentPage: Scalars['Int']['output'];
  items: Array<SportActivity>;
  /** Total number of items based on provided query. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on provided query. If there are no items, this value is 0. */
  totalPages: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  activityLevel?: Maybe<ActivityLevel>;
  aiCredits: AiCredits;
  avatarUrl: Scalars['String']['output'];
  calorieGoal?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  entitlements: Array<Entitlement>;
  firstName: Scalars['String']['output'];
  fitnessGoal?: Maybe<FitnessGoal>;
  gender?: Maybe<Gender>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type UserAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type UserInput = {
  activityLevel?: InputMaybe<ActivityLevel>;
  calorieGoal?: InputMaybe<Scalars['Int']['input']>;
  firstName: Scalars['String']['input'];
  fitnessGoal?: InputMaybe<FitnessGoal>;
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<Scalars['Float']['input']>;
  lastName: Scalars['String']['input'];
};

export type Workout = {
  __typename?: 'Workout';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  difficulty?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  niceId: Scalars['NiceId']['output'];
  note?: Maybe<Scalars['String']['output']>;
  plannedAt: Scalars['DateTime']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Dimension types for workout set measurements */
export enum WorkoutSetDimension {
  Calories = 'CALORIES',
  Distance = 'DISTANCE',
  HeartRate = 'HEART_RATE',
  Reps = 'REPS',
  Time = 'TIME',
  Weight = 'WEIGHT',
}

export type _Entity = Meal | SportActivity | User | Workout;

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY',
}

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    avatarUrl: string;
    createdAt: Date;
    height?: number | null;
    gender?: Gender | null;
    fitnessGoal?: FitnessGoal | null;
    activityLevel?: ActivityLevel | null;
    calorieGoal?: number | null;
  };
};

export type DeleteCurrentUserMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DeleteCurrentUserMutation = {
  __typename?: 'Mutation';
  deleteCurrentUser: boolean;
};

export type UpdateCurrentUserMutationVariables = Exact<{
  input: UserInput;
}>;

export type UpdateCurrentUserMutation = {
  __typename?: 'Mutation';
  updateCurrentUser: {
    __typename?: 'User';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    avatarUrl: string;
    createdAt: Date;
    height?: number | null;
    gender?: Gender | null;
    fitnessGoal?: FitnessGoal | null;
    activityLevel?: ActivityLevel | null;
    calorieGoal?: number | null;
  };
};

export type GetMealQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetMealQuery = {
  __typename?: 'Query';
  meal: {
    __typename?: 'Meal';
    id: string;
    name: string;
    brand?: string | null;
    barcode?: string | null;
    servingUnit: ServingUnit;
    servingSize: number;
    category?: { __typename?: 'MealCategory'; id: string } | null;
    nutritionalInfo?: {
      __typename?: 'MealNutritionalInfo';
      energyKcal: number;
      protein: number;
      carbs: number;
      fats: number;
      fibre: number;
      waterMl?: number | null;
    } | null;
    servingUnits: Array<{
      __typename?: 'MealServingUnit';
      id: string;
      name: string;
      weightGrams: number;
      sortIndex: number;
    }>;
  };
};

export type GetMealCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMealCategoriesQuery = {
  __typename?: 'Query';
  mealCategories: Array<{
    __typename?: 'MealCategory';
    id: string;
    title?: Record<Language, string> | null;
  }>;
};

export type MealCategoryFragment = {
  __typename?: 'MealCategory';
  id: string;
  title?: Record<Language, string> | null;
};

export type MealListItemFragment = {
  __typename?: 'Meal';
  id: string;
  name: string;
  brand?: string | null;
  servingUnit: ServingUnit;
  servingSize: number;
  user?: { __typename?: 'User'; id: string } | null;
};

export type MealNutritionalInfoFragment = {
  __typename?: 'MealNutritionalInfo';
  energyKcal: number;
  protein: number;
  carbs: number;
  fats: number;
  fibre: number;
  waterMl?: number | null;
};

export type MealServingUnitFragment = {
  __typename?: 'MealServingUnit';
  id: string;
  name: string;
  weightGrams: number;
  sortIndex: number;
};

export type MealWithNutritionFragment = {
  __typename?: 'Meal';
  id: string;
  name: string;
  brand?: string | null;
  barcode?: string | null;
  servingUnit: ServingUnit;
  servingSize: number;
  category?: { __typename?: 'MealCategory'; id: string } | null;
  nutritionalInfo?: {
    __typename?: 'MealNutritionalInfo';
    energyKcal: number;
    protein: number;
    carbs: number;
    fats: number;
    fibre: number;
    waterMl?: number | null;
  } | null;
  servingUnits: Array<{
    __typename?: 'MealServingUnit';
    id: string;
    name: string;
    weightGrams: number;
    sortIndex: number;
  }>;
};

export type MealsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type MealsByIdsQuery = {
  __typename?: 'Query';
  mealsByIds: Array<{
    __typename?: 'Meal';
    id: string;
    name: string;
    brand?: string | null;
    barcode?: string | null;
    servingUnit: ServingUnit;
    servingSize: number;
    category?: { __typename?: 'MealCategory'; id: string } | null;
    nutritionalInfo?: {
      __typename?: 'MealNutritionalInfo';
      energyKcal: number;
      protein: number;
      carbs: number;
      fats: number;
      fibre: number;
      waterMl?: number | null;
    } | null;
    servingUnits: Array<{
      __typename?: 'MealServingUnit';
      id: string;
      name: string;
      weightGrams: number;
      sortIndex: number;
    }>;
  }>;
};

export type SaveMealMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  input: MealInput;
}>;

export type SaveMealMutation = {
  __typename?: 'Mutation';
  saveMeal: {
    __typename?: 'Meal';
    id: string;
    name: string;
    brand?: string | null;
    barcode?: string | null;
    servingUnit: ServingUnit;
    servingSize: number;
    category?: { __typename?: 'MealCategory'; id: string } | null;
    nutritionalInfo?: {
      __typename?: 'MealNutritionalInfo';
      energyKcal: number;
      protein: number;
      carbs: number;
      fats: number;
      fibre: number;
      waterMl?: number | null;
    } | null;
    servingUnits: Array<{
      __typename?: 'MealServingUnit';
      id: string;
      name: string;
      weightGrams: number;
      sortIndex: number;
    }>;
  };
};

export type SearchMealsQueryVariables = Exact<{
  query?: InputMaybe<MealListQuery>;
}>;

export type SearchMealsQuery = {
  __typename?: 'Query';
  meals: {
    __typename?: 'MealResultPage';
    items: Array<{
      __typename?: 'Meal';
      id: string;
      name: string;
      brand?: string | null;
      servingUnit: ServingUnit;
      servingSize: number;
      user?: { __typename?: 'User'; id: string } | null;
    }>;
  };
};

export type SpecialMealsQueryVariables = Exact<{
  special: SpecialMeal;
}>;

export type SpecialMealsQuery = {
  __typename?: 'Query';
  meals: {
    __typename?: 'MealResultPage';
    items: Array<{
      __typename?: 'Meal';
      id: string;
      name: string;
      brand?: string | null;
      barcode?: string | null;
      servingUnit: ServingUnit;
      servingSize: number;
      category?: { __typename?: 'MealCategory'; id: string } | null;
      nutritionalInfo?: {
        __typename?: 'MealNutritionalInfo';
        energyKcal: number;
        protein: number;
        carbs: number;
        fats: number;
        fibre: number;
        waterMl?: number | null;
      } | null;
      servingUnits: Array<{
        __typename?: 'MealServingUnit';
        id: string;
        name: string;
        weightGrams: number;
        sortIndex: number;
      }>;
    }>;
  };
};

export type ExecutePowerSyncBatchMutationVariables = Exact<{
  input: PowerSyncBatchInput;
}>;

export type ExecutePowerSyncBatchMutation = {
  __typename?: 'Mutation';
  executePowerSyncBatch: {
    __typename?: 'PowerSyncOperationResult';
    success: boolean;
    message: string;
    affectedRows?: number | null;
  };
};

export type AiCreditsQueryVariables = Exact<{ [key: string]: never }>;

export type AiCreditsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    aiCredits: {
      __typename?: 'AiCredits';
      balance: number;
      monthlyAllotment?: number | null;
    };
  };
};

export type GetSportActivityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetSportActivityQuery = {
  __typename?: 'Query';
  sportActivity: {
    __typename?: 'SportActivity';
    id: string;
    name: Record<Language, string>;
    defaultDimensions?: Array<WorkoutSetDimension> | null;
    category: {
      __typename?: 'SportActivityCategory';
      id: string;
      title: Record<Language, string>;
    };
    muscleTargets: Array<{
      __typename?: 'MuscleTarget';
      id: string;
      muscle: Muscle;
      muscleGroup: MuscleGroup;
      intensity: number;
    }>;
  };
};

export type SaveSportActivityMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  input: SportActivityInput;
}>;

export type SaveSportActivityMutation = {
  __typename?: 'Mutation';
  saveSportActivity: {
    __typename?: 'SportActivity';
    id: string;
    name: Record<Language, string>;
    defaultDimensions?: Array<WorkoutSetDimension> | null;
    category: {
      __typename?: 'SportActivityCategory';
      id: string;
      title: Record<Language, string>;
    };
    muscleTargets: Array<{
      __typename?: 'MuscleTarget';
      id: string;
      muscle: Muscle;
      muscleGroup: MuscleGroup;
      intensity: number;
    }>;
  };
};

export type UserFragment = {
  __typename?: 'User';
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  avatarUrl: string;
  createdAt: Date;
  height?: number | null;
  gender?: Gender | null;
  fitnessGoal?: FitnessGoal | null;
  activityLevel?: ActivityLevel | null;
  calorieGoal?: number | null;
};

export type SearchSportActivitiesQueryVariables = Exact<{
  query?: InputMaybe<SportActivityListQuery>;
}>;

export type SearchSportActivitiesQuery = {
  __typename?: 'Query';
  sportActivities: {
    __typename?: 'SportActivityResultPage';
    items: Array<{ __typename?: 'SportActivity'; id: string }>;
  };
};

export const MealCategoryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MealCategoryFragment, unknown>;
export const MealListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Meal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingSize' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MealListItemFragment, unknown>;
export const MealNutritionalInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealNutritionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealNutritionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energyKcal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protein' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carbs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fats' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fibre' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waterMl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MealNutritionalInfoFragment, unknown>;
export const MealServingUnitFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealServingUnit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealServingUnit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weightGrams' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortIndex' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MealServingUnitFragment, unknown>;
export const MealWithNutritionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealWithNutrition' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Meal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'barcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingSize' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nutritionalInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealNutritionalInfo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'servingUnits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealServingUnit' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealNutritionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealNutritionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energyKcal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protein' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carbs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fats' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fibre' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waterMl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealServingUnit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealServingUnit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weightGrams' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortIndex' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MealWithNutritionFragment, unknown>;
export const UserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'User' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fitnessGoal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calorieGoal' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFragment, unknown>;
export const CurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'User' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'User' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fitnessGoal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calorieGoal' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const DeleteCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'deleteCurrentUser' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCurrentUserMutation,
  DeleteCurrentUserMutationVariables
>;
export const UpdateCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCurrentUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCurrentUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'User' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'User' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fitnessGoal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calorieGoal' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCurrentUserMutation,
  UpdateCurrentUserMutationVariables
>;
export const GetMealDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMeal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealWithNutrition' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealNutritionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealNutritionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energyKcal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protein' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carbs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fats' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fibre' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waterMl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealServingUnit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealServingUnit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weightGrams' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortIndex' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealWithNutrition' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Meal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'barcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingSize' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nutritionalInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealNutritionalInfo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'servingUnits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealServingUnit' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMealQuery, GetMealQueryVariables>;
export const GetMealCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMealCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mealCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealCategory' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMealCategoriesQuery,
  GetMealCategoriesQueryVariables
>;
export const MealsByIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MealsByIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UUID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mealsByIds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealWithNutrition' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealNutritionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealNutritionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energyKcal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protein' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carbs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fats' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fibre' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waterMl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealServingUnit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealServingUnit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weightGrams' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortIndex' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealWithNutrition' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Meal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'barcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingSize' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nutritionalInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealNutritionalInfo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'servingUnits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealServingUnit' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MealsByIdsQuery, MealsByIdsQueryVariables>;
export const SaveMealDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveMeal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MealInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveMeal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealWithNutrition' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealNutritionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealNutritionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energyKcal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protein' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carbs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fats' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fibre' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waterMl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealServingUnit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealServingUnit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weightGrams' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortIndex' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealWithNutrition' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Meal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'barcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingSize' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nutritionalInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealNutritionalInfo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'servingUnits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealServingUnit' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveMealMutation, SaveMealMutationVariables>;
export const SearchMealsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchMeals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MealListQuery' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MealListItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Meal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingSize' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchMealsQuery, SearchMealsQueryVariables>;
export const SpecialMealsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SpecialMeals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'special' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialMeal' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'special' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'special' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MealWithNutrition' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealNutritionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealNutritionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energyKcal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protein' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carbs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fats' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fibre' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waterMl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealServingUnit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MealServingUnit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weightGrams' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortIndex' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MealWithNutrition' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Meal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'barcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'servingSize' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nutritionalInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealNutritionalInfo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'servingUnits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MealServingUnit' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SpecialMealsQuery, SpecialMealsQueryVariables>;
export const ExecutePowerSyncBatchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExecutePowerSyncBatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PowerSyncBatchInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'executePowerSyncBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affectedRows' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExecutePowerSyncBatchMutation,
  ExecutePowerSyncBatchMutationVariables
>;
export const AiCreditsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AiCredits' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aiCredits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'balance' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monthlyAllotment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiCreditsQuery, AiCreditsQueryVariables>;
export const GetSportActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSportActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sportActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultDimensions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muscleTargets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'muscle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'muscleGroup' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intensity' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSportActivityQuery,
  GetSportActivityQueryVariables
>;
export const SaveSportActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveSportActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SportActivityInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveSportActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultDimensions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muscleTargets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'muscle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'muscleGroup' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intensity' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveSportActivityMutation,
  SaveSportActivityMutationVariables
>;
export const SearchSportActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchSportActivities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SportActivityListQuery' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sportActivities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchSportActivitiesQuery,
  SearchSportActivitiesQueryVariables
>;
export const namedOperations = {
  Query: {
    CurrentUser: 'CurrentUser',
    GetMeal: 'GetMeal',
    GetMealCategories: 'GetMealCategories',
    MealsByIds: 'MealsByIds',
    SearchMeals: 'SearchMeals',
    SpecialMeals: 'SpecialMeals',
    AiCredits: 'AiCredits',
    GetSportActivity: 'GetSportActivity',
    SearchSportActivities: 'SearchSportActivities',
  },
  Mutation: {
    DeleteCurrentUser: 'DeleteCurrentUser',
    UpdateCurrentUser: 'UpdateCurrentUser',
    SaveMeal: 'SaveMeal',
    ExecutePowerSyncBatch: 'ExecutePowerSyncBatch',
    SaveSportActivity: 'SaveSportActivity',
  },
  Fragment: {
    MealCategory: 'MealCategory',
    MealListItem: 'MealListItem',
    MealNutritionalInfo: 'MealNutritionalInfo',
    MealServingUnit: 'MealServingUnit',
    MealWithNutrition: 'MealWithNutrition',
    User: 'User',
  },
};
